import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as s from "./index.module.scss";

const Awards = ({ data }) => {
  return (
    <section className={`section-center ${s.awards}`}>
      <Container>
        <h2 className="title fw-bold">{data?.title || ""}</h2>
        <Row className={`${s.image_container}`}>
          {data?.awards?.map((item, idx) => {
            return (
              <Col key={idx} xs={5} md={3}>
                <img
                  loading="lazy"
                  src={item?.logo?.url}
                  alt={item?.logo?.alt || "logo"}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Awards;
